<template>
    <div class="vibe-popup-container">
        <popup-modal @setAction="handleSetAction" @cancelAction="handleCancelAction">
            <div class="popup-wrapper">
                <p class="title">Vibe</p>
                <div class="subtitle">
                    <p>Tag keywords that echo your venue's ambiance and audience.</p>
                    <p>These will help match you with compatible artists.</p>
                </div>

                <div class="field-inputs">
                    <div v-if="keywords.length" class="keyword-tags">
                        <div v-for="(tag, indx) in keywords" :key="indx" class="tag-wrapper">
                            <span @click="handleDeleteTag(indx)" class="tag">{{ tag }}</span>
                        </div>
                    </div>

                    <input
                        v-model="vibe"
                        :class="compErrMsg ? 'invalid-input' : ''"
                        @keyup.enter="handleAddTag"
                        type="text"
                        maxlength="25"
                        name="keyword"
                        placeholder="Add more tags here"
                    />

                    <div class="suggested-tags">
                        <p class="title">Suggested tags:</p>
                        <div
                            v-for="(tag, indx) in suggestedKeywords"
                            :key="indx"
                            class="tag-wrapper"
                        >
                            <span
                                class="tag"
                                :class="{ 'selected-tag': tag.selected }"
                                @click="handleSelectTag(tag)"
                            >
                                {{ tag.name }}
                            </span>
                        </div>
                        <div class="load-more-keywords">
                            <span>+ Load more tags</span>
                        </div>
                    </div>
                </div>
                <div v-if="compErrMsg" class="input-err-msg">{{ compErrMsg }}</div>
            </div>
        </popup-modal>
    </div>
</template>
<script>
    import PopupModal from '@/components/user/login-popups/PopupModal.vue'
    import useKeywords from '@/composables/useKeywords.js'

    const suggestedTags = [
        {
            name: 'Cover songs',
            selected: false
        },
        {
            name: 'Classic rock',
            selected: false
        },
        {
            name: 'Jazz',
            selected: false
        },
        {
            name: 'Lounge music',
            selected: false
        },
        {
            name: 'All Ages',
            selected: false
        },
        {
            name: 'Women-led business',
            selected: false
        },
        {
            name: 'LBGTIQ+ Friendly',
            selected: false
        },
        {
            name: 'Family oriented',
            selected: false
        },
        {
            name: '21 and over',
            selected: false
        }
    ]
    export default {
        name: 'Vibe',

        components: {
            'popup-modal': PopupModal
        },

        emits: ['closeModalAction'],

        setup() {
            const {
                suggestedKeywords,
                compErrMsg,
                keywords,
                handleSelectTag,
                handleDeleteTag,
                validate,
                formatTags,
                updateInfo
            } = useKeywords(suggestedTags)

            return {
                suggestedKeywords,
                compErrMsg,
                keywords,
                handleSelectTag,
                handleDeleteTag,
                validate,
                formatTags,
                updateInfo
            }
        },

        data: () => ({
            vibe: ''
        }),

        methods: {
            prepInfoData() {
                let data = {
                    keyword: this.formatTags(this.keywords)
                }

                return data
            },

            async handleSetAction() {
                if (!this.keywords.length) {
                    this.compErrMsg =
                        '[422] : You must enter or select at least one keyword to continue.'
                } else if (this.validate()) {
                    let infoData = this.prepInfoData()

                    await this.updateInfo(infoData)
                    this.$emit('closeModalAction')
                } else {
                    return
                }
            },

            handleCancelAction() {
                this.keywords.splice(0, this.keywords.length)
                this.compErrMsg = ''
                this.$emit('closeModalAction')
            },

            handleAddTag() {
                this.keywords.push(this.vibe)
                this.vibe = ''
            }
        }
    }
</script>
<style lang="scss" scoped>
    .popup-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin-left: 90px;

        .title {
            margin-top: 50px;
            margin-bottom: 0px;
            color: #dedede;
            font-size: 44px;
            font-family: Instrument Sans;
            font-style: normal;
            font-weight: 500;
            line-height: 110%;
            letter-spacing: -1.76px;
        }

        .subtitle {
            margin-top: 24px;

            p {
                color: #acacac;
                font-size: 16px;
                font-family: Instrument Sans;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
                margin-top: 0px;
                margin-bottom: 0px;
            }
        }

        .field-inputs {
            margin-top: 25px;

            .keyword-tags,
            .suggested-tags {
                display: flex;
                flex-direction: row;
                gap: 10px;
                margin-top: 52px;
                flex-wrap: wrap;
                min-height: 150px;
                max-width: 980px;

                .title {
                    color: #8b8b8b;
                    min-width: 153px;
                    font-family: Instrument Sans;
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 120%;
                    letter-spacing: -0.2px;
                    margin-top: 0px !important;
                    margin-bottom: 0px !important;
                }

                .tag-wrapper {
                    flex: 0 0 auto;
                }
            }

            span {
                padding: 11px 30px 12px 30px;
                border-radius: 100px;
                border: 1.5px solid #8b8b8b;
                background: #262626;
                color: #8b8b8b;
                font-size: 18px;
                font-family: Instrument Sans;
                font-style: normal;
                font-weight: 550;
                line-height: 120%;
            }

            span:hover {
                cursor: pointer;
            }

            .keyword-tags {
                span:hover {
                    background: #d7eb5a;
                }
            }

            .suggested-tags {
                .selected-tag {
                    background: #d7eb5a;
                }
            }

            input {
                min-width: 980px;
                padding: 12px 15px 15px 15px;
                border-radius: 12px;
                border: 1.5px solid #8b8b8b;
                background: #262626;
                color: #8b8b8b;
                font-family: Instrument Sans;
                font-size: 20px;
                font-style: normal;
                font-weight: 550;
                line-height: 120%;
                letter-spacing: -0.2px;
            }

            input::placeholder {
                color: #8b8b8b;
                font-family: Instrument Sans;
                font-size: 20px;
                font-style: normal;
                font-weight: 550;
                line-height: 120%;
                letter-spacing: -0.2px;
            }
        }
    }
</style>
